import { Organization, WithContext } from 'schema-dts';

// Single source of truth for Udacity's brand identity. Reused across the standalone
// Organization JSON-LD nodes and the minimal inline Course provider so values stay DRY.
export const UDACITY_ORGANIZATION_NAME = 'Udacity';
export const UDACITY_ORGANIZATION_URL = 'https://www.udacity.com/';

// Absolute URL to the Udacity logo. Used for the Organization `image`/`logo`
// fields and for the `Product.image` field on subscription listing pages so
// Google's merchant listing rich result has the required image.
export const UDACITY_LOGO_IMAGE = 'https://www.udacity.com/images/udacity-accenture-logo.svg';

export const UDACITY_ORGANIZATION: Organization = {
  '@type': 'Organization',
  name: UDACITY_ORGANIZATION_NAME,
  legalName: 'Udacity, Inc.',
  image: UDACITY_LOGO_IMAGE,
  url: UDACITY_ORGANIZATION_URL,
};

// Detailed Organization entity for the standalone Organization JSON-LD rendered on
// brand hub pages (homepage, about). Powers Google Knowledge Panel / brand rich results.
// Carries its own @context so it can be serialized directly as a top-level node.
export const UDACITY_ORGANIZATION_DETAILS: WithContext<Organization> = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: UDACITY_ORGANIZATION_NAME,
  url: UDACITY_ORGANIZATION_URL,
  logo: 'https://www.udacity.com/images/udacity-accenture-logo.png',
  description:
    "Udacity is the world's fastest, most efficient way to master the skills tech companies want. 100% online, part-time & self-paced.",
  email: 'support@udacity.com',
  sameAs: [
    'https://www.facebook.com/Udacity/',
    'https://www.linkedin.com/company/udacity',
    'https://x.com/udacity',
    'https://www.instagram.com/udacity/',
    'https://www.youtube.com/user/Udacity',
  ],
};
